// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d2e5f98c","977":"a2eb0c45"}[chunkId] + ".chunk.js";
};